import * as React from 'react';

import { useCatalogs } from './hooks';
import { TSuburbanCatalog } from '../../../types/suburbanCatalog';
import { SuburbanCatalogs } from '../../components/SuburbanCatalogs';

interface ISuburbanCatalogsContainerProps {
  catalogsTypes: TSuburbanCatalog[];
  fullWidth?: boolean;
}

export const SuburbanCatalogsContainer: React.VFC<ISuburbanCatalogsContainerProps> = ({ catalogsTypes, fullWidth }) => {
  const catalogs = useCatalogs(catalogsTypes);

  if (!catalogs.length) {
    return null;
  }

  return <SuburbanCatalogs catalogs={catalogs} fullWidth={fullWidth} />;
};
